<template>
  <div class="chat-widget-integration">
    <p class="chat-widget-integration__title">
      {{ t('onboarding.publication.widget-integration-title') }}
    </p>
    <p class="text-body-2 mb-2">
      {{ t('onboarding.publication.widget-integration-subtitle') }}
    </p>
    <p
      class="chat-widget-integration__details mb-2"
      v-html="t('onboarding.publication.widget-integration-description[0]')"
    />
    <p class="chat-widget-integration__details mb-3">
      {{ t('onboarding.publication.widget-integration-description[1]') }}
    </p>
    <v-checkbox
      :model-value="checked"
      color="white"
      false-icon="mdi-checkbox-blank"
      density="compact"
      hide-details
      :disabled="busy"
      :label="t('onboarding.publication.widget-integration-checkbox')"
      class="chat-widget-integration__checkbox"
      @update:model-value="onCheckboxChange"
    />
    <v-img
      src="/img/makler-mitte.png"
      max-height="120"
      class="chat-widget-integration__image my-3"
    />
    <v-alert
      type="info"
      color="#EEF4FF"
      density="compact"
      class="chat-widget-integration__alert"
      :text="t('onboarding.publication.widget-integration-alert')"
    />
    <v-btn
      v-if="!checked"
      variant="text"
      size="small"
      color="white"
      class="chat-widget-integration__decline px-0 mt-2"
      :disabled="busy"
      @click="decline"
    >
      {{ t('onboarding.wizard.chat-widgets.widget-integration-decline') }}
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  formKey: string
  busy?: boolean
  initialValue?: boolean | null
}>()

const emit = defineEmits<{
  confirm: [payload: { formKey: string; enabled: boolean; userMessage: string }]
}>()

const { t } = useI18n()
const checked = ref(props.initialValue === true)

watch(
  () => props.initialValue,
  (value) => {
    checked.value = value === true
  }
)

const onCheckboxChange = (value: boolean | null) => {
  if (!value) return
  checked.value = true
  emit('confirm', {
    formKey: props.formKey,
    enabled: true,
    userMessage: t('onboarding.publication.widget-integration-checkbox'),
  })
}

const decline = () => {
  checked.value = false
  emit('confirm', {
    formKey: props.formKey,
    enabled: false,
    userMessage: t('onboarding.wizard.chat-widgets.widget-integration-decline'),
  })
}
</script>

<style scoped>
.chat-widget-integration {
  padding: 16px;
  background-color: #1b9185;
  border-radius: 12px;
  color: white;
  max-width: 100%;
}

.chat-widget-integration__title {
  margin-bottom: 8px;
  font-weight: 700;
  font-size: 1.125rem;
  line-height: 1.3;
}

.chat-widget-integration__details {
  margin-bottom: 0;
  font-size: 0.875rem;
  line-height: 1.4;
}

.chat-widget-integration__details :deep(a) {
  color: #fff !important;
}

.chat-widget-integration__checkbox :deep(.v-label) {
  color: white;
  font-weight: 700;
  opacity: 1;
}

.chat-widget-integration__checkbox :deep(.v-selection-control__input > .v-icon) {
  opacity: 1;
}

.chat-widget-integration__image {
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
}

.chat-widget-integration__alert :deep(.v-alert__content),
.chat-widget-integration__alert :deep(.v-alert__prepend i) {
  color: #1d7fc9;
}

.chat-widget-integration__decline {
  text-transform: none;
  letter-spacing: normal;
  opacity: 0.9;
}
</style>
